import { render, staticRenderFns } from "./acceptedSupervision.vue?vue&type=template&id=2eabe958&scoped=true"
import script from "./acceptedSupervision.vue?vue&type=script&lang=js"
export * from "./acceptedSupervision.vue?vue&type=script&lang=js"
import style0 from "./acceptedSupervision.vue?vue&type=style&index=0&id=2eabe958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eabe958",
  null
  
)

export default component.exports